import { IconButton } from "@/components/form"
import Pagination from "@/components/table/Pagination"
import { faCloudDownload, faFilter, faTableList } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { computed, ref } from "vue"
import {
	defineComponent,
	getPageCount,
	inferProps,
	ScrollPane,
	ShadowContainer,
	type ReactiveComponent,
} from "vue-utils"
import { useEditingSearchState } from "../../state"
import SearchMarriageClaimTable from "./SearchMarriageClaimTable"

interface Props {
	managingFilters: boolean
	openManageColumns(): void
	openManageFilters(): void
	openChooseExportType(): void
}

const tableHeaderFormatting = css`
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;

	ul {
		padding-left: 0;
	}

	div {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		padding: 0 !important;
	}

	@media only screen and (max-width: 914px) {
		gap: 0.5rem;
	}
`

const SearchMarriageClaimsHeader: ReactiveComponent<Props> = (props) => {
	const state = useEditingSearchState()
	const totalPages = computed(() => getPageCount(state.fullSearchOptions.PageSize, state.fullResults.TotalItems))
	const pageSize = ref<number>(state.pageSize)

	function setPageSize() {
		if (pageSize.value === 0) {
			state.pageSize = 1
		} else if (pageSize.value > 200) {
			state.pageSize = 200
		} else {
			state.pageSize = pageSize.value
		}
	}

	return () => (
		<ShadowContainer class="d-flex flex-column">
			<div class="d-flex justify-content-between align-content-center flex-wrap mb-2" style="height: 2.5rem">
				<h5 class="mb-0">Claims</h5>
				<div class="d-flex gap-1">
					<IconButton color="manage" icon={faTableList} onClick={props.openManageColumns} title="Search">
						Manage Columns
					</IconButton>
					{!props.managingFilters && (
						<IconButton color="manage" icon={faFilter} onClick={props.openManageFilters} title="Manage Filters">
							Manage Filters
						</IconButton>
					)}
				</div>
			</div>
			<div class={tableHeaderFormatting}>
				<IconButton color="primary" icon={faCloudDownload} onClick={props.openChooseExportType} title="Export Results">
					Export Results
				</IconButton>
				{/* <IconButton
					color="primary"
					icon={faCloudDownload}
					onClick={() => void Api.marriageClaims.updateEligibility()}
					title="Export Results"
				>
					Update Eligibility
				</IconButton> */}
				<div>
					<h6 class="mb-0">Page Size:</h6>
					<input style="width: 4rem;" type="number" min={1} max={200} v-model={pageSize.value} onChange={setPageSize} />
					<Pagination
						page={state.fullResults.PageNumber}
						totalPages={totalPages.value}
						maxButtons={7}
						setPage={(page) => state.changePage(page)}
					/>
				</div>
			</div>
			<ScrollPane class="w-full flex-grow-1 mt-2">
				<SearchMarriageClaimTable />
			</ScrollPane>
		</ShadowContainer>
	)
}

export default defineComponent(SearchMarriageClaimsHeader, inferProps<Props>())
